'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import { styled } from 'styled-components';
import { dontForwardProps, InternalProvider } from '../../util';
import { getFontSize, getFontWeight, getFontFamily } from '../../abstracts/typography';
const TextElement = styled.span.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1rplm9h-0"
})(["font-family:", ";", " font-weight:", ";line-height:", ";margin:0;", " ", ""], ({
  $fontFamily
}) => getFontFamily($fontFamily), ({
  $fontSize
}) => $fontSize !== 'unset' ? `font-size: ${getFontSize($fontSize)};` : '', ({
  $fontWeight
}) => getFontWeight($fontWeight), ({
  $lineHeight
}) => $lineHeight ?? '1.2', ({
  $color
}) => $color ? `color: ${$color};` : '', ({
  $strikethrough
}) => $strikethrough && 'text-decoration: line-through;');
export const Text = /*#__PURE__*/forwardRef(({
  as = 'span',
  family = 'default',
  size = 2,
  weight = 'base',
  lineHeight,
  color,
  strikethrough = false,
  ...rest
}, fRef) => /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(TextElement, _extends({
  "data-aui": "text",
  $fontFamily: family,
  $fontSize: size,
  $fontWeight: weight,
  $color: color,
  $lineHeight: lineHeight,
  $strikethrough: strikethrough,
  ref: fRef,
  as: as
}, rest))));